import React from "react";

const Success = () => {

  return (
    <div className="d-flex justify-content-center">
        <div className="alert alert-success" role="alert">
            <small className="d-flex justify-content-start">
                <span className="me-2"><i className="fa-solid fa-check-double"></i></span>
                <span>Talebiniz başarıyla işleme alınmıştır.</span>
            </small>
        </div>
    </div>
  );
};

export default Success;